  module.exports = function () {
    const contentWithMedias = document.querySelectorAll(".content-with-media");
    if ( !contentWithMedias.length ) return;
    
    for (const contentWithMedia of contentWithMedias) {
        const button = contentWithMedia.querySelector(".content-with-media__video");
        
        const video = contentWithMedia?.querySelector("video");
        const poster = contentWithMedia?.querySelector("picture");
        const icon = contentWithMedia?.querySelector("button");

        if ( !(button && video && icon) ) continue;

        button?.addEventListener("click", () => {
            if ( video.readyState === 0 ) {
                video.setAttribute("src", video.dataset.src);
            }
            
            if ( video.paused ) {
                video.play().then(() => {
                    icon.classList.add("invisible", "opacity-0");
                    poster?.remove();
                }).catch((e) => {
                    console.error("Video error:", e);
                })
            }
            else {
                video.pause();
                icon.classList.remove("invisible", "opacity-0");
            }
        })
    }
  }